import { productApiClient } from '@/clients/ProductAPIClient';
import { ISalesTeam } from '@/data/models/salesTerritory';
import { useQuery, UseQueryResult } from '@tanstack/react-query';

export default function useGetAllowedSalesTeamsQuery(
  albumId?: string | number | null
): UseQueryResult<ISalesTeam[] | undefined, Error> {
  return useQuery({
    queryKey: ['allowedSalesTeams', albumId],
    queryFn: async () => {
      if (albumId) {
        return await productApiClient
          .getAllowedSalesTeams(albumId.toString())
          .then((response) => response.data);
      }
    },
    enabled: albumId != null,
    staleTime: Infinity,
  });
}
